// Import the RTK Query methods from the React-specific entry point
import { createSlice } from '@reduxjs/toolkit';

import {
  ROUTE_MONITORING_HEADERS,
  ROUTE_MONITORING_HEADERS_REALTIME,
  ROUTE_MONITORING_NAME_WIDTH_DEFAULT,
} from 'appConstants';

const initialState: {
  showCreateModal: boolean;
  loading: boolean;
  realtimeOn: boolean;
  hovered?: string;
  nameWidth: number | undefined;
  othersExpanded: boolean;
} = {
  realtimeOn: false,
  loading: true,
  showCreateModal: false,
  hovered: undefined,
  nameWidth: 0,
  othersExpanded: false,
};

export const routeMonitoringSlice = createSlice({
  name: 'routeMonitoring',
  initialState,
  reducers: {
    setRMCreateRouteModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setRmOthersExpanded: (state, action) => {
      state.othersExpanded = action.payload;
    },
    setRmLoading: (state, action) => {
      state.loading = action.payload;
    },
    setRmRealtimeOn: (state, action) => {
      state.realtimeOn = action.payload;
    },
    setRmHovered: (state, action) => {
      state.hovered = action.payload;
    },
    incrementRmNameWidth: (state, action) => {
      state.nameWidth = Math.max(
        ROUTE_MONITORING_NAME_WIDTH_DEFAULT,
        ROUTE_MONITORING_NAME_WIDTH_DEFAULT + action.payload,
      );
    },
  },
});
const { actions } = routeMonitoringSlice;

export const {
  setRMCreateRouteModal,
  setRmRealtimeOn,
  setRmLoading,
  setRmHovered,
  incrementRmNameWidth,
  setRmOthersExpanded,
} = actions;

export function selectRouteMonitoringState(rootState) {
  return rootState.routeMonitoring || initialState;
}

export const selectRmCreateRouteModal = (rootState) => {
  return selectRouteMonitoringState(rootState).showCreateModal;
};

export const selectRmOthersExpanded = (rootState) => {
  return selectRouteMonitoringState(rootState).othersExpanded;
};

export const selectRmRealtimeOn = (rootState) => {
  return selectRouteMonitoringState(rootState).realtimeOn;
};

export const selectRmHovered = (rootState) => {
  return selectRouteMonitoringState(rootState).hovered;
};

export const selectRmLoading = (rootState) => {
  return selectRouteMonitoringState(rootState).loading;
};

export const selectRmNameWidth = (rootState) => {
  return selectRouteMonitoringState(rootState).nameWidth
    ? selectRouteMonitoringState(rootState).nameWidth
    : ROUTE_MONITORING_NAME_WIDTH_DEFAULT;
};

export const selectRouteMonitoringHeaders = (rootState) => {
  if (selectRmRealtimeOn(rootState)) return ROUTE_MONITORING_HEADERS_REALTIME;
  return ROUTE_MONITORING_HEADERS;
};
